import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

/** Circular spectrum mirror — classic club look. */
export const spectrumViz: Visualizer = {
  id: 'spectrum',
  label: 'Spectrum Arc',
  draw(frame) {
    const { ctx, w, h, freq, bands, t } = frame;
    clearBg(ctx, w, h, 0.38);
    const cx = w / 2;
    const cy = h * 0.55;
    const base = Math.min(w, h) * 0.16;
    const n = Math.min(96, freq.length);
    for (let i = 0; i < n; i++) {
      const v = freq[Math.floor((i / n) * freq.length)] / 255;
      const a0 = -Math.PI + (i / n) * Math.PI;
      const a1 = -Math.PI + ((i + 0.85) / n) * Math.PI;
      const r0 = base;
      const r1 = base + v * Math.min(w, h) * (0.22 + bands.bass * 0.08);
      ctx.beginPath();
      ctx.arc(cx, cy, r1, a0, a1);
      ctx.arc(cx, cy, r0, a1, a0, true);
      ctx.closePath();
      ctx.fillStyle = `hsla(${165 + i * 1.2 + t * 15 + bands.highs * 40}, 92%, ${48 + v * 30}%, ${0.35 + v * 0.55})`;
      ctx.fill();
    }
    // reflection
    ctx.save();
    ctx.globalAlpha = 0.28;
    ctx.translate(0, cy + 8);
    ctx.scale(1, -0.55);
    ctx.translate(0, -cy);
    for (let i = 0; i < n; i += 2) {
      const v = freq[Math.floor((i / n) * freq.length)] / 255;
      const a0 = -Math.PI + (i / n) * Math.PI;
      const a1 = -Math.PI + ((i + 0.85) / n) * Math.PI;
      const r0 = base;
      const r1 = base + v * Math.min(w, h) * 0.2;
      ctx.beginPath();
      ctx.arc(cx, cy, r1, a0, a1);
      ctx.arc(cx, cy, r0, a1, a0, true);
      ctx.closePath();
      ctx.fillStyle = `hsla(${175 + i}, 90%, 55%, ${0.3 + v * 0.4})`;
      ctx.fill();
    }
    ctx.restore();
    drawHud(frame);
  },
};
